const KEY = 'primeink:manual-logout';
let blockedInMemory = false;
export function automaticLoginBlocked() {
  try { return blockedInMemory || localStorage.getItem(KEY) === '1'; } catch (_) { return blockedInMemory; }
}
export function blockAutomaticLogin() {
  blockedInMemory = true;
  try { localStorage.setItem(KEY, '1'); } catch (_) { /* Retain the choice for this page. */ }
}
export function allowAutomaticLogin() {
  blockedInMemory = false;
  try { localStorage.removeItem(KEY); } catch (_) { /* Retain the choice for this page. */ }
}
